import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { logo } from "../../../assets/img";

import PersonalDetails from "../../../Components/RegisterDetails/PersonalDetails";
import QualificationDetails from "../../../Components/RegisterDetails/QualificationDetails";
import ExperienceDetails from "../../../Components/RegisterDetails/ExperienceDetails";

import { registerUser, getEmployeeById } from "../../../api/register";

const Register = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isView = !!id;
  const token = localStorage.getItem("token");

  const [activeSection, setActiveSection] = useState("personal");
  const [loading, setLoading] = useState(false);

  const [personalData, setPersonalData] = useState({});
  const [qualificationData, setQualificationData] = useState({});

  const emptyExperience = {
    companyname: "",
    location: "",
    designation: "",
    joiningDate: "",
    relievingDate: "",
    experience: "",
  };

  const [experienceData, setExperienceData] = useState([emptyExperience]);

  const [errors, setErrors] = useState({
    personal: {},
    qualification: {},
    experience: [],
  });

  // ================= FETCH =================
  useEffect(() => {
    if (id) {
      getEmployeeById(id)
        .then((res) => {
          const emp = res.data.employee;

          setPersonalData(emp);
          setQualificationData(emp.qualification || {});

          const exp = emp.experience?.filter(Boolean) || [];

          setExperienceData(exp.length ? exp : [emptyExperience]);
        })
        .catch(() => toast.error("Failed to fetch employee data"));
    } else if (token) {
      setPersonalData({
        username: "",
        password: "",
        employeeId: "",
        salutation: "",
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        age: "",
        bloodgroup: "",
        martialstatus: "",
        presentaddress: "",
        permanentaddress: "",
        fathername: "",
        mothername: "",
        mobilenumber: "",
        aadharnumber: "",
        pannumber: "",
        uannumber: "",
        personalmailid: "",
        officialmailid: "",
        emergency: "",
        location: "",
        reportingmanager: "",
        designation: "",
        role: "employee",
      });

      setQualificationData({});
      setExperienceData([emptyExperience]);
      setErrors({ personal: {}, qualification: {}, experience: [] });
    }
  }, [id, token]);

  // ================= VALIDATION =================
  const validatePersonal = () => {
    const err = {};
    const pd = personalData;

    if (!pd.username) err.username = "Username required";
    if (!pd.password) err.password = "Password required";
    if (!pd.employeeId) err.employeeId = "Employee ID required";

    if (!pd.mobilenumber) err.mobilenumber = "Mobile required";
    else if (!/^[6-9]\d{9}$/.test(pd.mobilenumber))
      err.mobilenumber = "Invalid mobile";

    if (!pd.aadharnumber) err.aadharnumber = "Aadhar required";
    else if (!/^\d{12}$/.test(pd.aadharnumber))
      err.aadharnumber = "Invalid Aadhar";

    if (!pd.pannumber) err.pannumber = "PAN required";

    setErrors((prev) => ({ ...prev, personal: err }));

    return Object.keys(err).length === 0;
  };

  // ================= SUBMIT =================
const handleFinalSubmit = async () => {
  const formData = new FormData();

Object.keys(personalData).forEach((key) => {
  if (
    personalData[key] !== undefined &&
    personalData[key] !== null &&
    key !== "profileImage"
  ) {
    if (key === "role") {
      // ✅ FORCE STRING ONLY
      const roleValue = Array.isArray(personalData.role)
        ? personalData.role[0]
        : personalData.role;

      formData.set("role", roleValue || "employee");
    } else {
      formData.append(key, personalData[key]);
    }
  }
});

  // ✅ CLEAN EXPERIENCE (FINAL FIX)
  const cleanedExperience = (experienceData || [])
    .map((exp) => ({
      companyname: exp.companyname?.trim() || "",
      location: exp.location?.trim() || "",
      designation: exp.designation?.trim() || "",
      joiningDate: exp.joiningDate || null,
      relievingDate: exp.relievingDate || null,
      experience: exp.experience || "",
    }))
    .filter(
      (exp) =>
        exp.companyname ||
        exp.location ||
        exp.designation ||
        exp.joiningDate ||
        exp.relievingDate
    );

  console.log("FINAL EXPERIENCE:", cleanedExperience);

  formData.append("experience", JSON.stringify(cleanedExperience || []));
  formData.append("qualification", JSON.stringify(qualificationData));

  try {
    await registerUser(formData);
    alert("Employee registered successfully");
  } catch (err) {
    console.error(err);
  }
};
  // ================= UI =================
  return (
    <div className="register-container">
      <div className="register-header">
        <img src={logo} className="logo2222" alt="logo" />
        <h1>{isView ? "Employee Profile" : "New Employee Registration"}</h1>
      </div>

      <div className="step-buttons">
        <button
          className={`step-btn ${
            activeSection === "personal" ? "active" : ""
          }`}
          onClick={() => setActiveSection("personal")}
        >
          Personal Details
        </button>

        <button
          className={`step-btn ${
            activeSection === "qualification" ? "active" : ""
          }`}
          onClick={() => setActiveSection("qualification")}
        >
          Qualification Details
        </button>

        <button
          className={`step-btn ${
            activeSection === "experience" ? "active" : ""
          }`}
          onClick={() => setActiveSection("experience")}
        >
          Experience Details
        </button>
      </div>

      <div className="form-card">
        {activeSection === "personal" && (
          <PersonalDetails
            data={personalData}
            setData={setPersonalData}
            errors={errors.personal}
            disabled={isView}
          />
        )}

        {activeSection === "qualification" && (
          <QualificationDetails
            data={qualificationData}
            setData={setQualificationData}
            errors={errors.qualification}
            setErrors={(fieldErrors) =>
              setErrors((prev) => ({
                ...prev,
                qualification: fieldErrors,
              }))
            }
            disabled={isView}
          />
        )}

        {activeSection === "experience" && (
          <ExperienceDetails
            data={experienceData}
            setData={setExperienceData}
          />
        )}
      </div>

      {!isView && (
        <button
          className="register_btn mt-4 mb-4"
          onClick={handleFinalSubmit}
          disabled={loading}
        >
          {loading ? "Registering..." : "Register Employee"}
        </button>
      )}
    </div>
  );
};

export default Register;